var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sr-loader"},[_c('vue-skeleton-loader',{attrs:{"type":"rect","rounded":"","width":330,"height":440,"animation":"fade"}}),_c('vue-skeleton-loader',{staticClass:"sr-loader__right",attrs:{"type":"rect","rounded":"","width":'100%',"height":'100%',"animation":"fade"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }